import React, { useRef, useEffect } from "react";

const VideoPlayer = ({
  src,
  isPlaying,
  onPlayPause,
  showNativeControls = false,
}) => {
  const videoRef = useRef(null);

  // Sync external play/pause state
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (isPlaying) {
      video.play().catch((err) => console.error("Play error:", err));
    } else {
      video.pause();
    }
  }, [isPlaying]);

  const handleVideoClick = () => {
    if (onPlayPause) {
      onPlayPause(!isPlaying); // notify parent to toggle state
    }
  };

  return (
    <div className="video-container" style={{ position: "relative" }}>
      <video
        ref={videoRef}
        src={src}
        width="100%"
        height="300"
        controls={showNativeControls}
        style={{ borderRadius: "0"}}
        onClick={handleVideoClick} // Optional: Click to toggle
      />
    </div>
  );
};

export default VideoPlayer;
